/**
 * 工单每日数量走势组件
 */

import { useEffect, useState } from 'react';
import { Row, Col, Select, message, Input, InputNumber } from 'antd';
import { Chart } from '@antv/g2';
import $ from 'jquery';
import {
    isGTscreenWidth,
    UjoinParams,
    AddRequestHeaders,
} from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

const WOWTCD = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [isRefresh, setIsRefresh] = useState(true);
    const [data, setData] = useState([]);

    const [projectUlid, setProjectUlid] = useState('');
    const [projectDDList, setProjectDDList] = useState('');
    const [doUser, setDoUser] = useState('');
    const [timeInterval, setTimeInterval] = useState(180);
    const [level, setLevel] = useState(0);

    useEffect(() => {
        if (!props.data && projectDDList.length === 0) {
            const params = {
                'rss': 'list',
                'page_size': 65535,
                'current_index': 1
            };
            $.ajax({
                url: `${CNF.api}project/bases${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                crossDomain: true,
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        setProjectDDList(data.dat);
                    }
                }
            })
        }

    }, [props, projectDDList.length]);

    useEffect(() => {
        if (props.data) {
            setData(props.data);
        } else {
            if (isRefresh) {
                // 获取数据
                const params = {
                    'time_interval': timeInterval ? timeInterval : 180,
                    'level': level,
                    'do_user': doUser,
                    'project_ulid': projectUlid,
                }
                $.ajax({
                    url: `${CNF.api}reports/wo/wtcd${UjoinParams(params)}`,
                    headers: AddRequestHeaders(),
                    crossDomain: true,
                    type: 'GET',
                    dataType: 'JSON', success: function (data) {
                        if (data.res === 0) {
                            setData(data.dat);
                            setIsRefresh(false);
                        } else {
                            messageApi.error(data.msg, CNF.messageDuration);
                        }
                    }
                })
            }
        }
    }, [props, isRefresh, messageApi, timeInterval, level, doUser, projectUlid]);

    useEffect(() => {
        const chart = new Chart({
            container: 'antv-g2-id-wowtcd',
            autoFit: true,
        });

        if (!props.data) {
            chart.title({
                title: '工单每日数量走势',
                subtitle: '展示时间内（默认180天）每日工单数量统计。',
            });
        }

        chart.data(data);

        chart
            .line()
            .encode('x', 'date')
            .encode('y', 'count')
            .encode('shape', 'smooth')
            .scale('y', { independent: true })
            .scale('y', { nice: true })
            .scale('color', {
                range: CNF.swatches[CNF.currentSwatche],
            })
            .axis('x', { title: '日期', })
            .axis('y', {
                title: '数量',
                labelFormatter: (d) => `${d > 10000 ? (d / 10000).toFixed(CNF.DPL) : d}`
            })
            .animate('enter', {
                type: 'pathIn',
                duration: CNF.animateDuration + 1000,
            },)
            .tooltip({
                items: [
                    (d) => {
                        return { channel: 'y', value: `${d.count}个`, }
                    },
                ],
            })
            .style('lineWidth', 1)
            .style('stroke', global.THEMECOLOR);

        chart.render();

        return () => {
            chart.destroy();
        }
    }, [props, data]);

    return <>
        {contextHolder}
        {
            props.data ? '' : <Row style={{ margin: '15px 0 0 15px' }}>
                <Col span={isGTscreenWidth ? 5 : 6}>
                    <Select
                        showSearch
                        allowClear
                        placeholder='请选择项目'
                        style={{ width: '100%' }}
                        onChange={(value) => { setProjectUlid(value === undefined ? '' : value); setIsRefresh(true); }}
                        value={projectUlid ? projectUlid : undefined}
                        filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                        options={projectDDList && projectDDList.map((item, index) => ({
                            key: index,
                            value: item.key,
                            label: item.name,
                        }))}
                    />
                </Col>
                <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft, }}>
                    <Input
                        placeholder='处理人员'
                        onChange={(e) => { setDoUser(e.target.value); setIsRefresh(true); }}
                        value={doUser}
                    />
                </Col>
                <Col span={2} style={{ marginLeft: CNF.searchMarginLeft, }}>
                    <InputNumber
                        placeholder='时间区间'
                        style={{ width: '100%' }}
                        min={1}
                        max={365}
                        value={timeInterval > 0 ? timeInterval : null}
                        suffix='天'
                        onChange={(value) => { setTimeInterval(value); setIsRefresh(true); }}
                    />
                </Col>
                <Col span={2} style={{ marginLeft: CNF.searchMarginLeft, }}>
                    <Select
                        placeholder='工单等级'
                        style={{ width: '100%' }}
                        onChange={(value) => setLevel(value)}
                        value={level > 0 ? level : undefined}
                        options={CNF.woLevels.map((item, index) => ({
                            key: index,
                            value: item.value,
                            label: item.key
                        }))}
                    />
                </Col>
            </Row>
        }
        <div id='antv-g2-id-wowtcd'></div>
    </>

}

export default WOWTCD;